import './index';
import React from 'react';
import * as bootstrap from "bootstrap";
import { createRoot } from 'react-dom/client';
import AppRoutes from './components/routes';
import jquery from 'jquery';
import { HelmetProvider } from "react-helmet-async";


// Setup jQuery globally
window.jQuery = jquery;
window.$ = jquery;

require('jquery-validation');
require("select2/dist/css/select2");
require('select2')();
// Global select2 function
window.customSelect2 = function (id) {
  const $element = $(`#${id}`);
  if (!$element.length) {
    console.error(`Element with ID ${id} not found`);
    return;
  }

  $element.select2({
    placeholder: 'Select Marketplace',
    width: '100%',
    minimumInputLength: 0,
    ajax: {
      url: '/api/v1/marketplace_accounts/select_option',
      dataType: 'json',
      delay: 250,
      data: function (params) {
        return {
          term: params.term || ''
        };
      },
      processResults: function (data) {
        return {
          results: data.map(item => ({
            id: item[0],
            text: item[1]
          }))
        };
      },
      cache: true
    }
  });
};

import permissions from './components/common/permissions.json';
import "./channels"

//  Wrap AppRoutes in PermissionProvider
const root = createRoot(document.getElementById('root'));
root.render(
   <HelmetProvider>
    <div id="scroll-container">
      <AppRoutes />
    </div>
  </HelmetProvider>

);



// // Optional: Show a warning in console (discourages devtools access)
// console.log('%cProtected Content', 'color: red; font-size: 20px;');
// console.log('This page content is protected and not intended for copying or reuse.');
import "trix"
import "@rails/actiontext"
